/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordMemberJoinedBody
 */
export interface DiscordMemberJoinedBody {
    /**
     * The joining user's Discord id.
     * @type {string}
     * @memberof DiscordMemberJoinedBody
     */
    discordId: string;
    /**
     * Shared relay bot token (validated against DISCORD_BOT_RELAY_TOKEN by discordBotAuthentication).
     * @type {string}
     * @memberof DiscordMemberJoinedBody
     */
    botToken: string;
}

/**
 * Check if a given object implements the DiscordMemberJoinedBody interface.
 */
export function instanceOfDiscordMemberJoinedBody(value: object): value is DiscordMemberJoinedBody {
    if (!('discordId' in value) || value['discordId'] === undefined) return false;
    if (!('botToken' in value) || value['botToken'] === undefined) return false;
    return true;
}

export function DiscordMemberJoinedBodyFromJSON(json: any): DiscordMemberJoinedBody {
    return DiscordMemberJoinedBodyFromJSONTyped(json, false);
}

export function DiscordMemberJoinedBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordMemberJoinedBody {
    if (json == null) {
        return json;
    }
    return {
        
        'discordId': json['discordId'],
        'botToken': json['botToken'],
    };
}

export function DiscordMemberJoinedBodyToJSON(json: any): DiscordMemberJoinedBody {
    return DiscordMemberJoinedBodyToJSONTyped(json, false);
}

export function DiscordMemberJoinedBodyToJSONTyped(value?: DiscordMemberJoinedBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discordId': value['discordId'],
        'botToken': value['botToken'],
    };
}

